import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mosaic-long-push-atom',
  templateUrl: './mosaic-long-push-atom.component.html',
  styleUrls: ['./mosaic-long-push-atom.component.scss'],
  standalone: false,
})
export class MosaicLongPushAtomComponent {
  @Input() imageUrl?: string;
  @Input() title?: string;
  @Input() linkUrl!: string;
  @Input() aspectRatio?: string;
  @Input() rounded?: string;
  @Input() shadow?: string;
}
